<div (click)="onClickProfile(teacherProfile)">
  <div class="d-flex justify-content-center image-cropper">
    <app-image [src]="teacherProfile.imgUrl" [class]="'rounded-profile-img'"></app-image>
  </div>
  <div class="text-c100 body-m text-center">
    {{ teacherProfile.name }}
  </div>
</div>
